import { createI18n } from 'vue-i18n';
import frFR from '@/i18n/frFR'
import deDE from '@/i18n/deDE'
import enUS from '@/i18n/enUS'
import esES from '@/i18n/esES'

export type MessageSchema = typeof frFR;

const supportedLocales = ['fr', 'de', 'en', 'es'] as const;
type SupportedLanguages = (typeof supportedLocales)[number];

const i18n = createI18n<[MessageSchema], SupportedLanguages, false>({ 
    locale: "fr", 
    fallbackLocale: "fr", 
    messages: { 
        fr: frFR,
        de: deDE,
        en: enUS,
        es: esES,
    },
    legacy: false 
});

export function updateI18nLocale(locale: string): void {
  i18n.global.locale.value = supportedLocales.includes(locale as SupportedLanguages)
    ? (locale as SupportedLanguages)
    : 'fr';
}

export const TEMPLATE_RESOLVER = frFR.patient.document.variableResolver;

export default i18n;
